import type * as React from "react";
import { cn } from "../lib/cn.js";
import { fieldClasses } from "./input.js";

export function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea className={cn(fieldClasses, "min-h-24 resize-none py-2", className)} {...props} />
  );
}
